
export const colHeaders = [
  "<input type='checkbox' class='checker' data-row='-1' data-col='0' title='Select Up to first 50' />",
  //"User Id ",
  'Primary Location',
  'First Name ',
  'Middle Name/Initial ',
  'Last Name ',
  'Suffix ',
  'Email',
  'Phone ',
  //'Location Access User Rights',
  'Task Locations',
  'Department',
  'User Status',
  'Pinned Views for MyView',
  'Default MyView View',
  'Default Category',
  // 'Part Time',
  'Employee ID',
  'User Rights Group',
  'Title/Level',
  'IP Address Restriction',
  'Industry Group',
  'Niche/Group',
  'Expertise',
  // 'Residence City',
  'Primary Role',
  'Secondary Role',
  'Work Experience Begin Date',
  'Years of Experience',
  'Primary Billing Rate',
  'Secondary Billing Rate',
  'Last Logged On'
];


